var PlacementPosition = {
    TOP: "place_top",
    RIGHT: "place_right",
    BOTTOM: "place_bottom",
    LEFT: "place_left",
};
export var PlacementAlign = {
    START: "align_start",
    CENTER: "align_center",
    END: "align_end",
};
var PLACES = [PlacementPosition.BOTTOM, PlacementPosition.TOP, PlacementPosition.LEFT, PlacementPosition.RIGHT];
var ALIGNS = [PlacementAlign.CENTER, PlacementAlign.START, PlacementAlign.END];
var Placement = /** @class */ (function () {
    function Placement(referentRef, currentRef) {
        var _this = this;
        this.safeAreaMargin = 16;
        this.init = function () {
            if (!_this.referentRef || !_this.referentRef.current || !_this.currentRef || !_this.currentRef.current)
                return;
            _this.referentRect = _this.getRect(_this.referentRef.current);
            _this.currentRect = _this.getRect(_this.currentRef.current);
            _this.safeArea = _this.getSafeArea();
            _this.place = _this.getPlace();
            switch (_this.place) {
                case PlacementPosition.TOP:
                case PlacementPosition.BOTTOM:
                    _this.align = _this.getHorizontalAlign();
                    break;
                case PlacementPosition.LEFT:
                case PlacementPosition.RIGHT:
                    _this.align = _this.getVerticalAlign();
            }
        };
        this.getSafeArea = function () {
            if (!_this.referentRef || !_this.referentRef.current || !_this.currentRef || !_this.currentRef.current)
                return;
            var element = _this.currentRef.current;
            var isX, isY;
            var top = _this.safeAreaMargin;
            var right = window.innerWidth - _this.safeAreaMargin;
            var bottom = window.innerHeight - _this.safeAreaMargin;
            var left = _this.safeAreaMargin;
            while (element) {
                if (element === document.body || !element.parentElement) {
                    break;
                }
                element = element.parentElement;
                var style = window.getComputedStyle(element);
                var overflow = /(visible|(\w+))(\s(visible|(\w+)))?/.exec(style.overflow);
                if (!overflow) {
                    break;
                }
                isX = overflow[2] !== undefined;
                isY = overflow[3] !== undefined ? overflow[5] !== undefined : overflow[2] !== undefined;
                if (!isX && !isY)
                    continue;
                var rect = element.getBoundingClientRect();
                if (isX) {
                    if (rect.left > left)
                        left = rect.left;
                    if (rect.right < right)
                        right = rect.right;
                }
                if (isY) {
                    if (rect.top > top)
                        top = rect.top;
                    if (rect.bottom < bottom)
                        bottom = rect.bottom;
                }
            }
            return {
                top: top,
                right: right,
                bottom: bottom,
                left: left,
                center: left + (right - left) * 0.5,
                middle: top + (bottom - top) * 0.5,
            };
        };
        this.getPlace = function () {
            if (!_this.currentRect || !_this.referentRect || !_this.safeArea)
                return PLACES[0];
            for (var _i = 0, PLACES_1 = PLACES; _i < PLACES_1.length; _i++) {
                var place = PLACES_1[_i];
                switch (place) {
                    case PlacementPosition.TOP:
                        if (_this.referentRect.top - _this.currentRect.height > _this.safeArea.top)
                            return PlacementPosition.TOP;
                        break;
                    case PlacementPosition.RIGHT:
                        if (_this.referentRect.right + _this.currentRect.width < _this.safeArea.right)
                            return PlacementPosition.RIGHT;
                        break;
                    case PlacementPosition.BOTTOM:
                        if (_this.referentRect.bottom + _this.currentRect.height < _this.safeArea.bottom)
                            return PlacementPosition.BOTTOM;
                        break;
                    case PlacementPosition.LEFT:
                        if (_this.referentRect.left - _this.currentRect.width > _this.safeArea.left)
                            return PlacementPosition.LEFT;
                        break;
                }
            }
            return PLACES[0];
        };
        this.getHorizontalAlign = function () {
            if (!_this.currentRect || !_this.referentRect || !_this.safeArea)
                return ALIGNS[0];
            for (var _i = 0, ALIGNS_1 = ALIGNS; _i < ALIGNS_1.length; _i++) {
                var align = ALIGNS_1[_i];
                switch (align) {
                    case PlacementAlign.CENTER:
                        if (_this.referentRect.center - _this.currentRect.width * 0.5 > _this.safeArea.left &&
                            _this.referentRect.center + _this.currentRect.width * 0.5 < _this.safeArea.right)
                            return PlacementAlign.CENTER;
                        break;
                    case PlacementAlign.START:
                        if (_this.referentRect.left + _this.currentRect.width < _this.safeArea.right)
                            return PlacementAlign.START;
                        break;
                    case PlacementAlign.END:
                        if (_this.referentRect.right - _this.currentRect.width > _this.safeArea.left)
                            return PlacementAlign.END;
                        break;
                }
            }
            return ALIGNS[0];
        };
        this.getVerticalAlign = function () {
            if (!_this.currentRect || !_this.referentRect || !_this.safeArea)
                return ALIGNS[0];
            for (var _i = 0, ALIGNS_2 = ALIGNS; _i < ALIGNS_2.length; _i++) {
                var align = ALIGNS_2[_i];
                switch (align) {
                    case PlacementAlign.CENTER:
                        if (_this.referentRect.middle - _this.currentRect.height * 0.5 > _this.safeArea.top &&
                            _this.referentRect.middle + _this.currentRect.height * 0.5 < _this.safeArea.bottom)
                            return PlacementAlign.CENTER;
                        break;
                    case PlacementAlign.START:
                        if (_this.referentRect.top + _this.currentRect.height < _this.safeArea.bottom)
                            return PlacementAlign.START;
                        break;
                    case PlacementAlign.END:
                        if (_this.referentRect.bottom - _this.currentRect.height > _this.safeArea.top)
                            return PlacementAlign.END;
                        break;
                }
            }
            return ALIGNS[0];
        };
        this.getTranslate = function (translateXInit, translateYInit) {
            if (!_this.currentRect || !_this.referentRect)
                return undefined;
            var x, y;
            var currentRectTop = _this.currentRect.top - translateYInit;
            var currentRectLeft = _this.currentRect.left - translateXInit;
            switch (_this.place) {
                case PlacementPosition.TOP:
                    y = _this.referentRect.top - currentRectTop - _this.currentRect.height;
                    break;
                case PlacementPosition.RIGHT:
                    x = _this.referentRect.left - currentRectLeft + _this.referentRect.width;
                    break;
                case PlacementPosition.BOTTOM:
                    y = _this.referentRect.top - currentRectTop + _this.referentRect.height;
                    break;
                case PlacementPosition.LEFT:
                    x = _this.referentRect.left - currentRectLeft - _this.currentRect.width;
                    break;
            }
            switch (_this.place) {
                case PlacementPosition.TOP:
                case PlacementPosition.BOTTOM:
                    switch (_this.align) {
                        case PlacementAlign.CENTER:
                            x =
                                _this.referentRect.left -
                                    currentRectLeft +
                                    _this.referentRect.width * 0.5 -
                                    _this.currentRect.width * 0.5;
                            break;
                        case PlacementAlign.START:
                            x = _this.referentRect.left - currentRectLeft;
                            break;
                        case PlacementAlign.END:
                            x = _this.referentRect.left - currentRectLeft + _this.referentRect.width - _this.currentRect.width;
                            break;
                    }
                    break;
                case PlacementPosition.RIGHT:
                case PlacementPosition.LEFT:
                    switch (_this.align) {
                        case PlacementAlign.CENTER:
                            y =
                                _this.referentRect.top -
                                    currentRectTop +
                                    _this.referentRect.height * 0.5 -
                                    _this.currentRect.height * 0.5;
                            break;
                        case PlacementAlign.START:
                            y = _this.referentRect.top - currentRectTop;
                            break;
                        case PlacementAlign.END:
                            y = _this.referentRect.top - currentRectTop - _this.currentRect.height;
                            break;
                    }
                    break;
            }
            var translateX = x ? x + 0.5 : 0;
            var translateY = y ? y + 0.5 : 0;
            return {
                translateX: translateX,
                translateY: translateY,
            };
        };
        this.getPlaceValue = function () {
            if (!_this.place)
                return "top";
            return _this.place.replace("place_", "");
        };
        this.getAlignValue = function () {
            if (!_this.align)
                return "center";
            return _this.align.replace("align_", "");
        };
        this.getParentRect = function () {
            return _this.referentRect;
        };
        this.getCurrentRect = function () {
            return _this.currentRect;
        };
        this.referentRef = referentRef;
        this.currentRef = currentRef;
        this.init();
    }
    Placement.prototype.getRect = function (element) {
        var rect = element.getBoundingClientRect();
        return {
            bottom: rect.bottom,
            top: rect.top,
            left: rect.left,
            right: rect.right,
            height: rect.height,
            width: rect.width,
            x: rect.x,
            y: rect.y,
            center: rect.left + rect.width * 0.5,
            middle: rect.top + rect.height * 0.5,
        };
    };
    return Placement;
}());
export default Placement;
